import { useSearchParams } from 'next/navigation';

export default function useQueryParams() {
  const searchParams = useSearchParams();

  const { id, slug } = {
    id: searchParams.get('id'),
    slug: searchParams.get('slug'),
  };

  const checkSlugParam = (value: unknown) => typeof value === 'string' && value.startsWith('@');

  if (checkSlugParam(id)) {
    return {
      id: '',
      slug: id?.slice(1),
    };
  }

  if (checkSlugParam(slug)) {
    return {
      id,
      slug: slug?.slice(1),
    };
  }

  return {
    id,
    slug: '',
  };
}
